"use client";
/*
 * Documentation:
 * DC_Card_IconText — https://app.subframe.com/4f62853ee923/library?component=DC_Card_IconText_93c3ac79-9867-4619-8924-cff5da1b6209
 */

import React from "react";
import { FeatherShapes } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface Dc_Card_IconTextRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  headline?: React.ReactNode;
  text?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Dc_Card_IconTextRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Card_IconTextRootProps
>(function Dc_Card_IconTextRoot(
  {
    icon = <FeatherShapes />,
    headline,
    text,
    children,
    className,
    ...otherProps
  }: Dc_Card_IconTextRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full min-w-[224px] flex-col items-start gap-8 rounded-md bg-neutral-50 px-6 py-6",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {icon ? (
        <SubframeCore.IconWrapper className="text-heading-3 font-heading-3 text-default-font">
          {icon}
        </SubframeCore.IconWrapper>
      ) : null}
      <div className="flex w-full flex-col items-start gap-4">
        {headline ? (
          <span className="text-body-bold font-body-bold text-default-font">
            {headline}
          </span>
        ) : null}
        {children ? (
          <div className="flex w-full flex-col items-start gap-12">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
});

export const Dc_Card_IconText = Dc_Card_IconTextRoot;
